module.exports = __webpack_public_path__ + "img/tabler-icon-click.4a312f0a.svg";